import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './index.css'

import MediaRecorderPolyfill from 'audio-recorder-polyfill';

import * as Sentry from "@sentry/react";

if (import.meta.env.SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN){
  Sentry.init({
    dsn: import.meta.env.SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", import.meta.env.VITE_API_BASE],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

// Only use the polyfill for browsers without native compressed audio support (e.g. Safari).
// Chrome/Firefox support audio/webm natively, which is ~10x smaller than WAV.
try {
  if (typeof window.MediaRecorder === 'undefined' || !window.MediaRecorder.isTypeSupported('audio/webm')) {
    window.MediaRecorder = MediaRecorderPolyfill;
  }
} catch {
  window.MediaRecorder = MediaRecorderPolyfill;
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
